import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Asian%20woman%20model%20in%20flowing%20silk%20dress%2C%20artistic%20fashion%20editorial%20photography%2C%20soft%20dramatic%20lighting%2C%20luxurious%20atmosphere%2C%20warm%20golden%20and%20rose%20tones%2C%20clean%20minimal%20composition%2C%20high%20end%20magazine%20style%2C%20ethereal%20romantic%20mood%2C%20dark%20background%20with%20subtle%20texture&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
          alt="mm131高清写真图库"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 max-w-4xl mx-auto">
        <p className="text-primary-300 text-xs md:text-sm tracking-[0.3em] uppercase mb-4 animate-[fadeIn_0.8s_ease] font-label">
          Discover Beauty · Inspire Creativity
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight animate-[fadeIn_1s_ease]">
          {t('hero.title')}
        </h1>
        <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-2xl mx-auto animate-[fadeIn_1.2s_ease] font-body">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeIn_1.4s_ease]">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta')}
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-full text-sm font-medium hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.secondary')}
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12 animate-[fadeIn_1.6s_ease]">
          {[
            { num: '100,000+', label: '精选套图' },
            { num: '50+', label: '签约模特' },
            { num: '8', label: '风格分类' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.num}</p>
              <p className="text-xs text-background-300 mt-1 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}